import WarningIcon from '@material-ui/icons/Warning';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useHeaderTabsStyles from 'shared/components/common/headerTabs/TabStyles';
import { selectIsUserHasRequiredActionOnPendingPayRateTab } from 'modules/offerLetter/store/selectors';
import { selectIsPayRangesEnabledForClient } from 'store/entities/clients/selectors/configurationSelectors';
import {
    OfferLetterStatusSlug,
    offerLetterTabsSorted,
} from 'modules/offerLetter/store/model';

export function useOfferLetterTabs() {
    const isPayRangeEnabledForClient = useSelector(selectIsPayRangesEnabledForClient);
    const isClientHasPendingPayRateOffers = useSelector(selectIsUserHasRequiredActionOnPendingPayRateTab);
    const classes = useHeaderTabsStyles();

    return useMemo(() => {
        const warningIconMixin = isClientHasPendingPayRateOffers ? {
            icon: <WarningIcon className={classes.warningClass} />,
            classes: {
                wrapper: classes.iconLabelWrapper,
            },
        } : {};
        const result = [...offerLetterTabsSorted];
        if (isPayRangeEnabledForClient) {
            result.unshift({
                label: 'Rate Approval',
                value: OfferLetterStatusSlug.PendingPayRateApproval,
                ...warningIconMixin,
            });
        }
        return result;
    }, [isPayRangeEnabledForClient, isClientHasPendingPayRateOffers, classes]);
}
